import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <div className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/')}
            className="mb-8"
            data-testid="back-button"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-card border border-border rounded-lg p-8"
          >
            <h1 className="text-4xl font-heading font-bold mb-4">Privacy Policy</h1>
            <p className="text-sm text-muted-foreground mb-8">
              <strong>Effective Date:</strong> January 5, 2026
            </p>

            <div className="prose prose-invert max-w-none space-y-6 text-foreground">
              <p>
                At <strong>MyTestCase</strong> (accessible via{' '}
                <a href="https://mytestcase.com" className="text-blue-500 hover:underline">
                  https://mytestcase.com
                </a>
                ), we prioritize our visitors' privacy. This policy outlines how we collect and use data for our AI testing services.
              </p>

              <div>
                <h2 className="text-2xl font-heading font-semibold mb-3 mt-8">Information Collection</h2>
                <p>
                  We collect browser-related data (IP addresses, browser type) to optimize our AI agent performance.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-semibold mb-3 mt-8">Cookies</h2>
                <p>
                  We use cookies to maintain session states for our AI playground and dashboard.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-semibold mb-3 mt-8">Third-Party Services</h2>
                <p>
                  We use Google AdSense to serve ads. Google uses DART cookies to serve ads based on your visits to this and other sites. You can opt out via{' '}
                  <a
                    href="https://policies.google.com/technologies/ads"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline"
                  >
                    Google's Ad Settings
                  </a>
                  .
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-semibold mb-3 mt-8">Consent</h2>
                <p>
                  By using <strong>MyTestCase</strong> (accessible via{' '}
                  <a href="https://mytestcase.com" className="text-blue-500 hover:underline">
                    https://mytestcase.com
                  </a>
                  ), you consent to our data practices.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
